export default {
  API_PATH: 'https://healthunlocked.com/api/',
  SOLARIS_API_PATH: 'https://solaris.healthunlocked.com/',
  WS_URL: 'wss://healthunlocked.com/',
  WS_PATH: '/ws',

  CDN: {
    img: 'https://d2f7pix2c73koy.cloudfront.net',
    POST_IMG: 'https://d2f7pix2c73koy.cloudfront.net/post/post_',
    communityLogos: 'https://d2f7pix2c73koy.cloudfront.net/group-logos/',
    communityBanners: 'https://d2f7pix2c73koy.cloudfront.net/group-banners/',
    AVATARS: 'https://d2f7pix2c73koy.cloudfront.net/avatars/',
    GROUPS: 'https://d2f7pix2c73koy.cloudfront.net/group-logos/',
    emoji: 'https://d37jpvxvnmgnc2.cloudfront.net/betelgeuse/img/emoji/unicode/',
    smiley: 'https://d37jpvxvnmgnc2.cloudfront.net/aurora/images/smiley/',
  },

  DEFAULT_BANNER_URL: 'https://d37jpvxvnmgnc2.cloudfront.net/betelgeuse/img/gallery/default-banner_1170x250.png',
  DEFAULT_AVATAR_NAME: 'Hidden',
  DEFAULT_AVATAR_HASH: 'avatar_hidden',

  AVATAR_SMALL_SUFFIX: '_small@2x_100x100.jpg',

  TEMPORARY_PREFIX: '__TEMP__',
};



// WEBPACK FOOTER //
// ./~/virgo/src/constants.js